import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-khata',
  templateUrl: './e-khata.component.html',
  styleUrls: ['./e-khata.component.css']
})
export class EKhataComponent implements OnInit {
title="E-Khata"
title1="Installment"
title2="Maintainance Fee"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/e-khata/e-khata.component.ts